<div class="amount-formater-wrapper no-wrap-text" ng-class="{'has-underline':amountFormatter.hasUnderline}">
  <span ng-if="::amountFormatter.hasBracket" class="{{amountFormatter.bracketClasses}}"> / </span>
  <span
    class="{{amountFormatter.customCss + ' ' + amountFormatter.fontClasses[0]}}">{{amountFormatter.amountObj.intPart}}</span>
  <span
    class="{{amountFormatter.customCss + ' ' + amountFormatter.fontClasses[1]}}">{{amountFormatter.amountObj.decimal}}</span>
</div>